import axios from 'axios';

import config from '../config';

import { SuppliersSearchParam, SuppliersSearchResult, Okpd2Item, KladrItem } from '@/types/suppliers';

const instance = axios.create({
    baseURL: config.suppliersUrl,
    timeout: 10000000,
    withCredentials: true,
    headers: { Pragma: 'no-cache' }
});

export class SuppliersApi {
    public static search = (data: SuppliersSearchParam) => instance.post<SuppliersSearchResult>('/api/search/suppliers', data);

    public static getOkpd2List = () => instance.get<Array<Okpd2Item>>('/api/dictionary/okpd2');

    public static getKladrList = () => instance.get<Array<KladrItem>>('/api/dictionary/places');
}